export const TOOLTIP_DESCRIPTION = `Costs related to property damage and vandalism or looting due to public disturbances that occurred
    during 2020 that were not covered by insurance or other compensation.`;

export const TOOLTIP_NAME = 'coveredPropertyDamagesExpendituresCostsTooltip';
